var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_12941",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      maskType: "alpha"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_12941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 17.3337V21.3337C14.6667 21.7114 14.7945 22.0281 15.0501 22.2837C15.3056 22.5392 15.6223 22.667 16.0001 22.667C16.3779 22.667 16.6945 22.5392 16.9501 22.2837C17.2056 22.0281 17.3334 21.7114 17.3334 21.3337V17.3337H21.3334C21.7112 17.3337 22.0279 17.2059 22.2834 16.9503C22.539 16.6948 22.6667 16.3781 22.6667 16.0003C22.6667 15.6225 22.539 15.3059 22.2834 15.0503C22.0279 14.7948 21.7112 14.667 21.3334 14.667H17.3334V10.667C17.3334 10.2892 17.2056 9.97255 16.9501 9.71699C16.6945 9.46144 16.3779 9.33366 16.0001 9.33366C15.6223 9.33366 15.3056 9.46144 15.0501 9.71699C14.7945 9.97255 14.6667 10.2892 14.6667 10.667V14.667H10.6667C10.289 14.667 9.9723 14.7948 9.71675 15.0503C9.46119 15.3059 9.33342 15.6225 9.33342 16.0003C9.33342 16.3781 9.46119 16.6948 9.71675 16.9503C9.9723 17.2059 10.289 17.3337 10.6667 17.3337H14.6667ZM16.0001 29.3337C14.1556 29.3337 12.4223 28.9837 10.8001 28.2837C9.17786 27.5837 7.76675 26.6337 6.56675 25.4337C5.36675 24.2337 4.41675 22.8225 3.71675 21.2003C3.01675 19.5781 2.66675 17.8448 2.66675 16.0003C2.66675 14.1559 3.01675 12.4225 3.71675 10.8003C4.41675 9.1781 5.36675 7.76699 6.56675 6.56699C7.76675 5.36699 9.17786 4.41699 10.8001 3.71699C12.4223 3.01699 14.1556 2.66699 16.0001 2.66699C17.8445 2.66699 19.5779 3.01699 21.2001 3.71699C22.8223 4.41699 24.2334 5.36699 25.4334 6.56699C26.6334 7.76699 27.5834 9.1781 28.2834 10.8003C28.9834 12.4225 29.3334 14.1559 29.3334 16.0003C29.3334 17.8448 28.9834 19.5781 28.2834 21.2003C27.5834 22.8225 26.6334 24.2337 25.4334 25.4337C24.2334 26.6337 22.8223 27.5837 21.2001 28.2837C19.5779 28.9837 17.8445 29.3337 16.0001 29.3337Z",
    fill: "#B46C9F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.6fe940e374ebfe9aef6843bb3e777d6a.svg";
export { ForwardRef as ReactComponent };